// extracted by mini-css-extract-plugin
module.exports = {"ReadMore":"ReadMore_ReadMore__bAGJI","ReadMore_heading":"ReadMore_ReadMore_heading__vg2kF","ReadMore_links":"ReadMore_ReadMore_links__PvhF9"};